import axios from 'axios';

const API_V2 = process.env.REACT_APP_BACKEND_URL + '/api/v2';

export function AdminModeration({ moderation, setModeration }) {
  return (
    <div className="space-y-4">
      <h2 className="text-lg font-semibold">Content-Moderation</h2>
      <p className="text-sm text-gray-400">
        User mit Content-Verstößen. Nach 3 Strikes wird ein User automatisch gesperrt.
      </p>

      {moderation.length === 0 ? (
        <div className="bg-gray-800 rounded-xl p-6 text-center text-gray-400">
          Keine Verstöße bisher.
        </div>
      ) : (
        <div className="space-y-3">
          {moderation.map((m) => (
            <div key={m.userId} className={`rounded-xl p-4 ${m.blocked ? 'bg-red-900/30 border border-red-800' : 'bg-gray-800'}`}>
              <div className="flex items-center justify-between mb-2">
                <div>
                  <span className="font-medium">{m.userName}</span>
                  <span className="text-xs text-gray-400 ml-2">{m.userEmail}</span>
                </div>
                <div className="flex items-center gap-3">
                  <span className={`text-sm font-bold ${m.strikes >= 3 ? 'text-red-400' : m.strikes >= 2 ? 'text-yellow-400' : 'text-gray-400'}`}>
                    {m.strikes}/3 Strikes
                  </span>
                  {m.blocked && (
                    <button
                      onClick={async () => {
                        if (window.confirm(`${m.userName} entsperren und Strikes zurücksetzen?`)) {
                          try {
                            await axios.post(`${API_V2}/admin/unblock/${m.userId}`, {}, { withCredentials: true });
                            setModeration(moderation.filter(x => x.userId !== m.userId));
                          } catch (err) {
                            alert('Fehler: ' + (err.response?.data?.detail || err.message));
                          }
                        }
                      }}
                      className="px-3 py-1 text-xs bg-green-700 hover:bg-green-600 rounded-lg"
                    >
                      Entsperren
                    </button>
                  )}
                </div>
              </div>
              {m.blocked && <div className="text-xs text-red-400 mb-2">GESPERRT</div>}
              <div className="text-xs text-gray-500">
                <span>Letzter Verstoß: {m.lastStrike ? new Date(m.lastStrike).toLocaleString('de-DE') : '-'}</span>
              </div>
              <div className="mt-2 space-y-1">
                {m.blockedTexts?.map((t, i) => (
                  <div key={i} className="text-xs text-gray-400 bg-gray-900 rounded px-2 py-1 font-mono truncate">
                    {t}
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
